import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetCopyPriceList(club, from, to) {

  var url = "/reservation/copy_price_list/" + club + "/" + from + "/" + to; 

  return FetchGetDataWithAuthNEW(url);
}
